import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Box,
  Button,
  IconButton,
  InputAdornment,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Popover,
  createMuiTheme,
} from '@material-ui/core';
import styled from 'styled-components';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import COLORS from "scss/colors.module.scss";
import LinkIcon from '@material-ui/icons/Link';
import Tooltip from '@material-ui/core/Tooltip';
import Switch from '@material-ui/core/Switch';
import ApiClient from "utils/ApiClient";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ThemeProvider } from "@material-ui/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Moment from "moment";
const ShareRecord = ({ isOpen, onClose, rowId, listId, listConfig }) => {
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tokenLoading, setTokenLoading] = useState(false);
  const [containsEmail, setContainsEmail] = useState({});
  const [containsSubsheet, setContainsSubsheet] = useState({});
  const [containsFile, setContainsFile] = useState({});
  const [subsheetContainsFile, setSubsheetContainsFile] = useState({});
  const [subsheetContainsEmail, setSubsheetContainsEmail] = useState({});
  const [mappedData, setMappedData] = useState(null);
  const [namesData, setNamesData] = useState(null);
  const listConfigData = listConfig.listData;
  const [linkUrl, setLinkUrl] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [hiddenRows, setHiddenRows] = useState({});
  const [formattedDate, setFormattedDate] = useState("Expiration Date");
  const Renderer = KeyboardDatePicker;
  const inputRef = useRef(null);
  const defaultMaterialTheme = createMuiTheme({
    palette: {
      primary: { 500: COLORS.THEME_COLOR },
    },
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [expireState, setExpireState] = React.useState({
    checkedA: false,
    checkedB: false,
  });

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setExpireState((prevState) => ({ ...prevState, [name]: checked }));
    if (name === "checkedB" && checked) {
      setTimeout(() => {
        if (inputRef.current) {
          handlePopoverOpen({ currentTarget: inputRef.current });
        }
      }, 0);
    }
  };

  const handleTimeChange = (date) => {
    let moment = Moment(date).set({ hours: 0, minutes: 0, seconds: 0 });

    if (moment.year() === 2001 && !(date || "").includes("2001")) {
      moment.set("year", Moment().year());
    }

    const finalformattedDate = moment.format("MMM D, YYYY");
    const value = finalformattedDate;

    handlePopoverClose()
    setSelectedValue(value);
    setFormattedDate(value);

  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const toggleRowVisibility = (aliasName) => {
    setHiddenRows((prev) => {
      const newHiddenState = {
        ...prev,
        [aliasName]: !prev[aliasName],
      };

      const hiddenFields = Object.entries(newHiddenState)
        .filter(([key, isHidden]) => isHidden)
        .map(([key]) => {
          if (key == 'createdOn' || key == 'updatedOn') {
            return `${listConfigData.find(col => col.alias_name === key)?.id}`;
          } else {
            return `column_${listConfigData.find(col => col.alias_name === key)?.id}`;
          }
        });


      ApiClient.Record.saveHiddenFields({
        list_id: listId,
        row_id: rowId,
        hidden_fields: hiddenFields,
      })
        .then((data) => {
          // console.log('API Response for hidden/unhidden fields:', data.data);
        })
        .catch((error) => {
          console.error('Error fetching token for hidden/unhidden fields:', error);
        });
      return newHiddenState;
    });
  };


  const popoverOpen = Boolean(anchorEl);
  const popoverId = popoverOpen ? 'date-picker-popover' : undefined;

  useEffect(() => {
    async function fetchData() {
      if (isOpen) {
        if (!rowData) {
          setLoading(true);
          await ApiClient.List.getRowData({ list_id: listId, row_id: rowId })
            .then((data) => {
              setRowData(data);
            })
            .catch((error) => {
              console.error('Error fetching RowData:', error);
            });
        }
        if(linkUrl == "" || (expireState.checkedB && selectedValue) || (!expireState.checkedB && selectedValue)) {
          const payload = {
            list_id: listId,
            row_id: rowId,
            ...(expireState.checkedB && selectedValue && { time: selectedValue })
          };
          if (rowData) {
            setTokenLoading(true);
          }
          await ApiClient.Record.getToken(payload)
            .then((data) => {
              const token = data.data;
              let hiddenFields = data.hiddenFields || [];
              const newUrl = `${window.appStore.configStore.config.site.server_url}/record/view-record?key=${token}`;
              setLinkUrl(newUrl);
              setLoading(false);
              if (typeof hiddenFields === 'string') {
                try {
                  hiddenFields = JSON.parse(hiddenFields);
                } catch (e) {
                  console.error('Error parsing hiddenFields string:', e);
                }
              }
              if (Array.isArray(hiddenFields)) {
                const initialHiddenRows = {};
                hiddenFields.forEach((colId) => {
                  const id = colId.replace("column_", "");
                  const column = listConfigData.find(col => {
                    return col.id === id;
                  });

                  if (column) {
                    initialHiddenRows[column.alias_name] = true;
                  } else {
                    console.error("Column not found for");
                  }

                });
                setHiddenRows(initialHiddenRows);
              } else {
                console.error('hiddenFields is not an array:', hiddenFields);
              }
              setTokenLoading(false);
              setLoading(false);
            })
            .catch((error) => {
              setTokenLoading(false);
              setLoading(false);
              console.error('Error fetching token:', error);
            });
        }
        setLoading(false);
      }
    }
    fetchData();
  }, [expireState.checkedB, selectedValue]);

  useEffect(() => {
    if (rowData) {
      mapColumns(listConfigData, rowData);
    }
  }, [rowData]);

  const handleNotification = () => {
    window.appStore.notificationStore.showNotification(
      "Link copied successfully!",
      "success"
    );
  };

  function ensureArray(listConfigData) {
    return Array.isArray(listConfigData) ? listConfigData : Object.values(listConfigData);
  }

  function mapColumns(listConfigData, rowData) {
    const configArray = ensureArray(listConfigData);
    const result = {};
    const result_names = {};
    const emailColumns = {};
    const fileColumns = {};
    const subsheetFileColumns = {};
    const subsheetColumns = {};
    const subsheetEmailColumns = {};

    configArray.forEach((config) => {
      const columnId = config.id == "created_at" || config.id == "updated_at" ? config.id : `column_${config.id}`;
      // const columnId = `column_${config.id}`;

      if (rowData.data[columnId] !== undefined) {
        if (config.column_type_id === "6") {
          // Subsheet data
          subsheetColumns[config.alias_name] = true;
          const subsheetDataArray = rowData.data[columnId];
          result[config.alias_name] = subsheetDataArray.map(subsheetRow => {
            let subResult = {};
            config.list_columns.forEach(subsheetdata => {
              const subColumnId = `column_${subsheetdata.id}`;
              if (subsheetdata.column_type_id === "9") {
                subsheetFileColumns[subsheetdata.alias_name] = true;
                const subSheetFiledata = JSON.parse(subsheetRow[subColumnId] || "[]");
                subResult[subsheetdata.alias_name] = subSheetFiledata.map(file => ({
                  name: file.name,
                  path: file.fullpath,
                }));
              } else if (subsheetdata.column_type_id === "22") {
                const value = parseFloat(subsheetRow[subColumnId] || "0");
                subResult[subsheetdata.alias_name] = `${(value * 100).toFixed(2)}%`;
              } else if (subsheetdata.column_type_id === "14") {
                subsheetEmailColumns[subsheetdata.alias_name] = true;
                subResult[subsheetdata.alias_name] = subsheetRow[subColumnId] || null;
              }
              else {
                subResult[subsheetdata.alias_name] = subsheetRow[subColumnId] || null;
              }
              result_names[subsheetdata.alias_name] = subsheetdata.name;
            });
            return subResult;
          });
        } else if (config.column_type_id === "9") {
          // File data
          fileColumns[config.alias_name] = true;
          const fileData = JSON.parse(rowData.data[columnId] || "[]");
          result[config.alias_name] = fileData.map(file => ({
            name: file.name,
            path: file.fullpath,
          }));
        } else if (config.column_type_id === "22") {
          const value = parseFloat(rowData.data[columnId] || "0");
          result[config.alias_name] = `${(value * 100).toFixed(2)}%`;
        } else {
          result[config.alias_name] = rowData.data[columnId];
          if (config.column_type_id === "14") {
            emailColumns[config.alias_name] = true;
          }
        }
        result_names[config.alias_name] = config.name;
      }
    });
    setMappedData(result);
    setNamesData(result_names);
    setContainsEmail(emailColumns);
    setContainsFile(fileColumns);
    setContainsSubsheet(subsheetColumns);
    setSubsheetContainsFile(subsheetFileColumns);
    setSubsheetContainsEmail(subsheetEmailColumns);
  }

  const handleFileClick = (path) => {
    window.open(path, '_blank');
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="share-dialog-title"
      open={isOpen}
      PaperProps={{
        style: {
          width: '1200px',
          maxWidth: 'none',
          height: '800px',
        },
      }}
    >
      <DialogTitle id="share-dialog-title" onClose={onClose}>
        Share RowData
      </DialogTitle>
      <DialogContent
        dividers
        style={{ overflowX: 'auto', padding: '0px 24px' }}
      >
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <BoxContainer>
              <TextField
                id="outlined-basic"
                variant="outlined"
                disabled
                value={linkUrl}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {/* <Tooltip title="Copy Link" placement="top-end"> */}
                        <CopyToClipboard text={linkUrl} onCopy={handleNotification}>
                          <div style={{ display: 'flex', alignItems: 'center',fontSize:'small' }}>
                            <IconButton>
                            <LinkIcon />
                            </IconButton>
                            
                              <span>Copy Link</span>
                          </div>
                        </CopyToClipboard>
                      {/* </Tooltip> */}
                    </InputAdornment>
                  )
                }}
                inputProps={{
                  style:
                  {
                    color: 'gray',
                    width: expireState.checkedB ? '800px' : '800px'
                  }
                }}
              />
            
              <span style={{ display: 'flex', alignItems: 'center'}}>
                {tokenLoading ? (
                  <Box display="flex" justifyContent="center" alignItems="center" height="100%" margin='8px'>           
                      <CircularProgress size={22}/>
                  </Box>
                ) :  
                  <Tooltip title="Add expiration" placement="top">
                    <Switch
                      checked={expireState.checkedB}
                      onChange={handleChange}
                      name="checkedB"
                      color="primary"
                      
                    />
                  </Tooltip>
                }
                <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                  <HourglassEmptyIcon
                    style={{
                      color: expireState.checkedB ? '#757575' : '#757575',
                      marginRight: '3px'
                    }}
                  />
                  {!expireState.checkedB && <span style={{ fontSize: '12px', color: '#757575' }}>Set Expiration Date?</span>}
                </div>
              </span>

              {expireState.checkedB && (
                <>
                  <Button aria-describedby={popoverId} onClick={handlePopoverOpen} ref={inputRef}>
                    {formattedDate}
                  </Button>
                  <Popover
                    id={popoverId}
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <ThemeProvider theme={defaultMaterialTheme}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <Renderer
                          variant="static"
                          container="inline"
                          minDate={new Date()}
                          format="MM/dd/yyyy"
                          value={selectedValue}
                          onChange={(date) => {
                            // this.setExpireState({ formattedValue: false });
                            handleTimeChange(date);
                          }}
                          style={{ padding: "10px" }}
                        />
                      </MuiPickersUtilsProvider>
                    </ThemeProvider>
                  </Popover>
                </>
              )}
            </BoxContainer>
            {mappedData ? (
              <Box style={{ marginTop: '20px' }}>
                {Object.entries(mappedData).map(([key, value]) => (
                  <IconContainer
                    key={key}
                    className={hiddenRows[key] ? "hidden" : ""}
                    style={{
                      backgroundColor: hiddenRows[key] ? '#f0f0f0' : 'transparent',
                      borderRadius: '5px',
                    }}
                  >
                    <SubDiv>
                      <Typography component="span" variant="body1" style={{ fontWeight: 'bold',maxWidth:'200px', minWidth: '250px', wordBreak: 'break-word',marginRight:'10px' }}>
                        {namesData[key] ? namesData[key] : key}
                      </Typography>
                      <Typography component="span" variant="body1" style={{ textAlign: 'left', flex: 1 }}>
                        {containsFile[key] ? (
                          <div>
                            {value.map((file, index) => (
                              <span
                                key={index}
                                onClick={() => handleFileClick(file.path)}
                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', display: 'block' }}
                              >
                                {file.name}
                              </span>
                            ))}
                          </div>
                        ) : containsEmail[key] ? (
                          <a href={`mailto:${value}`} style={{ color: 'blue', textDecoration: 'underline' }}>
                            {value}
                          </a>
                        ) : containsSubsheet[key] && value && value.length > 0 ? (
                          <div>
                            <TableBoxContainer>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {Object.keys(value[0] || {}).map((header, index) => (
                                      <TableCell key={index}>
                                        <Typography style={{ fontWeight: 'bold' }}>{namesData[header] ? namesData[header] : header}</Typography>
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {value.map((rowData, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                      {Object.entries(rowData).map(([cellKey, cellData], cellIndex) => (
                                        <TableCell key={cellIndex}>
                                          <Typography>
                                            {subsheetContainsFile[cellKey] && Array.isArray(cellData) && cellData.length > 0 ? (
                                              cellData.map((file, fileIndex) => (
                                                <span
                                                  key={fileIndex}
                                                  onClick={() => handleFileClick(file.path)}
                                                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', display: 'block' }}
                                                >
                                                  {file.name}
                                                </span>
                                              ))
                                            ) : subsheetContainsEmail[cellKey] ? (
                                              <a href={`mailto:${cellData}`} style={{ color: 'blue', textDecoration: 'underline' }}>
                                                {cellData}
                                              </a>

                                            ) : (
                                              cellData || ' '
                                            )}
                                          </Typography>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableBoxContainer>
                          </div>
                        ) : (
                          <TypographyData>
                            {value}
                          </TypographyData>
                        )}
                      </Typography>

                      <IconButton
                        className="visibility-icon"
                        onClick={() => toggleRowVisibility(key)}
                      >
                        {hiddenRows[key] ? (
                          <Tooltip title="Show this field to the recipient" placement="top">
                            <VisibilityOffIcon />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Hide this field from the recipient" placement="top">
                            <VisibilityIcon />
                          </Tooltip>
                        )}
                      </IconButton>

                    </SubDiv>
                    <hr style={{ margin: '10px 0' }} />
                  </IconContainer>
                ))}
              </Box>
            ) : (
              <Typography color="textSecondary">No data available</Typography>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
      {linkUrl && (
        <Button
          onClick={() => window.open(linkUrl, "_blank")}
          color="primary"
        >
          Preview
        </Button>
      )}
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>

  );
};

export default ShareRecord;

const IconContainer = styled.div`
  position: relative;

  .visibility-icon {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  /* When the column is hidden, do not show the visibility icon and prevent hover effects */
  &.hidden .visibility-icon {
    opacity: 1;

  }

  /* When the column is visible, allow hover effect */
  &:not(.hidden):hover .visibility-icon {
    opacity: 1;
  }
`;


const BoxContainer = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: white;
  padding-bottom: 10px;
  padding-top: 10px;
  display: flex;
  align-items: center;
`;

const TableBoxContainer = styled.div`
  max-width: 850px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const TypographyData = styled.div`
 word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;

const SubDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
